import { Injectable } from "@angular/core";
import { ApiService } from "../global.service";
import { Observable } from "rxjs";
import { HttpBackend, HttpClient } from "@angular/common/http";
import { ConfigService } from "../config.service";
import { LocalStorageService } from "../storage.service";
import { BusinessContextService } from "../business-context.service";

export interface PosTerminal {
  uuid: string;
  name: string;
  enabled?: boolean;
  status?: string;
  updatedAt?: string | Date;
  total?: number;
}

@Injectable({ providedIn: 'root' })
export class PosTerminalService extends ApiService {
  constructor(
    public override http: HttpClient,
    public override config: ConfigService,
    public override localStorageService: LocalStorageService,
    handler: HttpBackend,
    private bizCtx: BusinessContextService,
  ) {
    super(http, config, localStorageService, handler);
  }

  /**
   * Lista los POS terminals.
   * Usa header `X-Business-Uuid` agregado por ApiService.
   * Endpoint: GET /api/v1/pos/terminals
   */
  getTerminals(): Observable<PosTerminal[]> {
    return this.get<PosTerminal[]>(`${this.URL}/pos/terminals`);
  }
}